var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDummyAvatar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#161F29",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8145 81.0448C90.9861 72.4384 96 60.8047 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 60.8047 5.01387 72.4383 13.1854 81.0448C14.8176 78.0437 17.1103 75.2761 20.2385 72.9377L20.1333 72.8905C22.6318 71.0077 25.6632 69.4061 29.3169 68.1871C31.399 67.4929 33.594 68.4733 35.1104 70.0491C38.3477 73.4113 42.893 75.5657 47.9717 75.7318L47.9986 75.7322L48.0283 75.7318C53.107 75.5656 57.6523 73.4113 60.8896 70.049C62.406 68.4733 64.601 67.4929 66.6831 68.187C70.3368 69.4061 73.3682 71.0077 75.8667 72.8904L75.7614 72.9377C78.8896 75.2761 81.1824 78.0437 82.8145 81.0448ZM48.0283 20.0017L47.9991 20.0021L47.9717 20.0017C43.2108 19.9323 38.6267 22.0122 35.2596 25.7693C31.893 29.5264 30.0291 34.642 30.091 39.955C30.0971 42.4268 30.493 44.7988 31.2145 46.9972C32.0497 49.9263 33.4277 52.6569 35.316 54.7641C38.6759 58.5136 43.2484 60.5926 47.9988 60.5322C52.75 60.5934 57.3235 58.5143 60.684 54.7641C63.7999 51.287 65.6285 46.6463 65.8345 41.7626C65.8823 41.1668 65.9075 40.5639 65.909 39.9549C65.9708 34.642 64.1069 29.5264 60.7404 25.7693C57.3733 22.0122 52.7892 19.9323 48.0283 20.0017Z",
    fill: "#BFF8F2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDummyAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dummyAvatar.ef35d9e97de5e98b82ff8d788f5b38b7.svg";